import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

type Props = SvgProps & { color?: string };

export const DesktopSearchIcon = ({ color, ...props }: Props) => (
    <Svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
        <Path
            d="M13.6773 13.6669C14.8039 12.5359 15.5003 10.9761 15.5003 9.25357C15.5003 5.79982 12.7005 3 9.24674 3C5.79298 3 2.99316 5.79982 2.99316 9.25357C2.99316 12.7073 5.79298 15.5071 9.24674 15.5071C10.978 15.5071 12.545 14.8036 13.6773 13.6669ZM13.6773 13.6669L17.011 17"
            stroke={color ?? ds.colorValue.icon.secondary}
            strokeWidth={1.75}
            strokeLinecap="round"
        />
    </Svg>
);
